import * as React from 'react';
import withContainer from '../../containers/WithContainer';
import { ContainerNew } from '../../containers/AppContainer';
import { withRouter, RouteComponentProps } from 'react-router';

interface NavBarProps extends RouteComponentProps {
  appContainer: ContainerNew;
}
interface State {
  isActive: String;
}
class NavBar extends React.Component<NavBarProps, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      isActive: '',
    };
  }

  toggleMenu = () => {
    if (this.state.isActive) {
      this.setState({
        isActive: '',
      });
    } else {
      this.setState({
        isActive: ' is-active',
      });
    }
  };

  render() {
    const { appContainer, location } = this.props;
    const paths = location.pathname.split('-') || [];
    return (
      <>
        <nav
          className="navbar justify-center"
          role="navigation"
          aria-label="main navigation"
        >
          <div className="navbar-brand justify-center">
            <a className="navbar-item">
              <img
                src="https://s3-ap-southeast-2.amazonaws.com/dashboard-uploads-2/flayr+gradient+text+logo.jpeg"
                width="90"
              />
            </a>
            {/*  <a onClick={this.toggleMenu} role="button" className={"navbar-burger burger" + this.state.isActive} aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
              <span aria-hidden="true" />
              <span aria-hidden="true" />
              <span aria-hidden="true" />
            </a> */}
          </div>
          {/*  <div id="navbarBasicExample" className={"navbar-menu" + this.state.isActive}>
            <div className="navbar-end nav-right">
              <div className="navbar-item ">
                <div className="buttons">
                  {this.props.appContainer.isLoggedIn() &&
                    <a onClick={() => { this.props.appContainer.logout() }} className="button is-light">
                      Log Out
                    </a>
                  }
                </div>
              </div>
            </div>
          </div> */}
        </nav>
        {!!paths.length && (
          <progress
            className="progress is-info is-xs is-radiusless"
            value={parseInt(paths[1]) || 0}
            max={appContainer.stepsMapping.length - 1}
          />
        )}
      </>
    );
  }
}

export default withRouter(withContainer(NavBar));
